import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function rigionalSalesOffice() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>DIVISIONAL / REGIONAL SALES OFFICES, GURGAON</h2>
                        <div class="clearfix"></div>
                        <table>
                          <tbody>
                            <tr>
                              <th scope="col">SL. No.</th>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Area of Operation</th>
                              <th scope="col">Telephone</th>
                              <th scope="col">Fax</th>
                              <th scope="col">E-mail ID</th>
                              <th scope="col">Address</th>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Shri Mukul Mathur</td>
                              <td>Dy. General Manager (Marketing)</td>
                              <td>Institution Sales</td>
                              <td>0124-4303747, 8285345164</td>
                              <td>0124-4303744</td>
                              <td>
                                <a href="mailto:Idplmukul2018@gmail.com">
                                  Idplmukul2018@gmail.com
                                </a>
                              </td>
                              <td rowspan="2">
                                Coprate Office: IDPL Complex, old Delhi Gurgaon
                                Road. Dundahera, Gurgaon -122016
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
